const isIe11 = !!window.MSInputMethodContext && !!document.DOCUMENT_NODE;
const hasIntersectionObserverSupport = 'IntersectionObserver' in window;
const hasLoadingSupport = !!window.HTMLImageElement && 'loading' in window.HTMLImageElement.prototype;
const checkIsMobileOrTablet = () => {
    return (typeof window.orientation !== 'undefined' ||
        !!navigator.userAgent.match(/IEMobile/) ||
        !!navigator.userAgent.match(/Android/i) ||
        !!navigator.userAgent.match(/webOS/i) ||
        !!navigator.userAgent.match(/iPhone/i) ||
        !!navigator.userAgent.match(/iPad/i) ||
        !!navigator.userAgent.match(/iPod/i) ||
        !!navigator.userAgent.match(/BlackBerry/i));
};

export { hasLoadingSupport as a, checkIsMobileOrTablet as c, hasIntersectionObserverSupport as h, isIe11 as i };

